import React from 'react';

// import components
import CtaBarForm from './CtaBarForm';

// import styled components
import { CtaBarModalScreen, CtaBarModalWindow } from './styled';

function CtaBarModal(props) {
  const {
    attr: { display, overflow, position },
    account,
    hideModal,
    name,
  } = props;

  return (
    <CtaBarModalScreen
      style={{
        display: display,
        overflow: overflow,
        position: position,
      }}
    >
      <CtaBarModalWindow>
        <CtaBarForm hideModal={hideModal} name={name} account={account} />
      </CtaBarModalWindow>
    </CtaBarModalScreen>
  );
}

export default CtaBarModal;
